export enum OfferItemActionType {
    tapClose,
    tapOpen,
    tapReveal,
    tapRepeatUnlock,
    tapFavorite,
    tapShare,
    tapShareApp,
    tapMerchantContact,
    tapResetSearch,
    tapMap,
    tapPhone,
    tapWebsite,
    tapSponsorWebsite,
    tapShowCashier,
    tapThumbsUp,
    tapThumbsDown,
    tapReview,

    whenExpanded,
    whenExpanding,
    whenMinimized,
    whenMinimizing,

    testThanks,
    testShowCashier,
    testResetOfferRedeemed,
    testResetOfferRevealed,
    testResetOfferRepeatUnlocked,
    testResetOfferThumbs,
    testResetOfferBounceback,
    testResetOfferVideo
}

export interface OfferItemAction {
    type: OfferItemActionType;
    data?: any;
}
